import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectChangeEvent } from "@mui/material";
import {
  LanguageSelect,
  LanguageSelectItem,
  LanguageSelectItemText,
  ListItemIconContainer,
  ListItemIconSelectedContainer,
  ListItemTextStyled,
  MenuItemContainer,
} from "./Header.styled";
import { LANGUAGE } from "../../constants/localStorage";
import { ReactComponent as SerbiaFlag } from "../../assets/images/svg/countries/rs.svg";
import { ReactComponent as MacedonianFlag } from "../../assets/images/svg/countries/mk.svg";
import { ReactComponent as SwedishFlag } from "../../assets/images/svg/countries/se.svg";
import { ReactComponent as EnglishFlag } from "../../assets/images/svg/countries/gb.svg";
import { ReactComponent as ChevronDown } from "../../assets/images/svg/chevron-down.svg";
import { ReactComponent as Check } from "../../assets/images/svg/check.svg";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(
    localStorage.getItem(LANGUAGE) || "sr"
  );

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value as string;
    i18n.changeLanguage(newValue);
    setSelectedValue(newValue);

    localStorage.setItem(LANGUAGE, newValue);
  };
  const options = [
    { value: "en", label: "Eng", Icon: EnglishFlag },
    { value: "sr", label: "Srb", Icon: SerbiaFlag },
    { value: "mk", label: "Mkd", Icon: MacedonianFlag },
    { value: "se", label: "Swe", Icon: SwedishFlag },
  ];

  return (
    <div>
      <LanguageSelect
        value={selectedValue}
        onChange={handleChange}
        MenuProps={{
          disableScrollLock: true,
          sx: {
            "&& .Mui-selected": {
              color: "#161616C2",
              background: "#F5E7E466",
            },
            "&& .MuiList-root": {
              paddingTop: "4px",
              paddingBottom: "4px",
            },
          },
        }}
        IconComponent={() => <ChevronDown width={16} height={16} />}
        renderValue={(value: any) => {
          const option = options.find((opt) => opt.value === value);
          if (!option) {
            return value;
          }
          return (
            <LanguageSelectItem>
              <option.Icon style={{ width: "24px", height: "18px" }} />
              <LanguageSelectItemText>{option.label}</LanguageSelectItemText>
            </LanguageSelectItem>
          );
        }}
      >
        {options.map((option) => (
          <MenuItemContainer key={option.value} value={option.value}>
            <ListItemIconContainer>
              <option.Icon width={24} height={18} />
            </ListItemIconContainer>
            <ListItemTextStyled>{option.label}</ListItemTextStyled>
            {option.value === selectedValue && (
              <ListItemIconSelectedContainer>
                <Check width={16} height={16} />
              </ListItemIconSelectedContainer>
            )}
          </MenuItemContainer>
        ))}
      </LanguageSelect>
    </div>
  );
};

export default LanguageSelector;
